// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {Component, PropTypes} from 'react';
import FocusTrap from 'react-focus-trap';
import {FormattedMessage} from 'react-intl';
import {WarrantyLargeModal} from '../../../shared/components/modal';
import {oktaLoginRequired} from '../../services/okta-login-required';

function handleLoginComplete() {

    oktaLoginRequired(false);

}

class SessionExpiredModal extends Component {

    componentWillMount() {

        window.signinComplete = handleLoginComplete.bind(this);

    }

    render() {

        return (
            <FocusTrap active={this.props.isOpen}>
                <section className='expired-modal'>
                    <WarrantyLargeModal isOpen={this.props.isOpen}>
                        <header>
                            <FormattedMessage id={'SIGN_IN_REQUIRED'}/>
                        </header>
                        <div className='modal-body'>
                            <iframe src='\'/>
                        </div>
                    </WarrantyLargeModal>
                </section>
            </FocusTrap>
        );

    }

}

SessionExpiredModal.displayName = 'ConfirmationModal';
SessionExpiredModal.propTypes = {
    isOpen: PropTypes.bool.isRequired
};

export default SessionExpiredModal;



// WEBPACK FOOTER //
// ./src/shared/components/session-expired-modal/index.js